module.exports = __webpack_public_path__ + "img/loading.2f27f045.gif";